export default __webpack_public_path__ + "static/media/slider__events.e44f60ee.png";